<template>
  <div class="sky-hc-content-header">
    <div class="sky-hc-content-header__con">
      <div class="sky-hc-content-header__left-nav">
        <left-nav :data="navList"></left-nav>
      </div>
      <div class="sky-hc-content-header__right-img" @click="handleClickBanner">
        <img :src="bannerImg" class="sky-hc-content-header__img" />
      </div>
    </div>
    <div class="sky-hc-content-header__nav" @click="toggleShowmore">
      <div class="sky-hc-content-header__nav-more" v-if="menuList.length > 6">
        <span class="sky-hc-content-header__nav-more-txt">更多</span>
        <span
          class="sky-hc-content-header__nav-more-icon"
          :class="showMore ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
        ></span>
      </div>
      <ul
        class="sky-hc-content-header__nav-list"
        :class="
          menuList.length > 6
            ? showMore
              ? 'sky-hc-content-header__nav-list--more'
              : 'sky-hc-content-header__nav-list--flex-start'
            : ''
        "
      >
        <li
          class="sky-hc-content-header__nav-item"
          v-for="(item, index) in menuList"
          :key="item.id"
          :class="currentCategory.id === item.id ? 'sky-hc-content-header__nav-item--active' : ''"
          @click="handleMenuClick(item, index)"
        >
          <tooltip-over :content="item.name" class="sky-hc-content-header__nav-item-txt" :refName="'tooltip' + index">
          </tooltip-over>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { Tooltip } from 'element-ui'

import LeftNav from '../components/leftNav'

import { getInsidePageSetting } from '@/api/help'
import TooltipOver from '@/components/tooltipOver'
export default {
  name: 'ContentHeader',
  components: {
    LeftNav,
    [Tooltip.name]: Tooltip,
    TooltipOver
  },
  props: {
    menuList: {
      type: Array,
      default() {
        return []
      }
    },
    category: {
      type: Object,
      default() {
        return {
          id: '',
          name: ''
        }
      }
    }
  },
  data() {
    return {
      navList: [],
      bannerImg: '',
      bannerLink: '',
      currentCategory: {
        id: '',
        name: ''
      },
      type: '',
      showMore: false
    }
  },
  watch: {
    category() {
      this.currentCategory = this.category
      this.$emit('catergoryChange', {item: this.currentCategory})
    }
  },
  created() {
    this.handleGetConfig()
  },
  methods: {
    handleGetConfig() {
      getInsidePageSetting().then(response => {
        const content = response.data.content
        if (content && content.quickLinks) {
          this.navList = content.quickLinks
        }
        this.bannerImg = content.bannerImg
        this.bannerLink = content.bannerLink
      })
    },
    handleMenuClick(item, index) {
      this.currentCategory = item
      this.$emit('catergoryTab', {item: item, index: index})
    },
    toggleShowmore() {
      this.showMore = !this.showMore
    },
    handleClickBanner() {
      if (!this.bannerLink) return
      window.open(this.bannerLink, 'help')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(hc-content-header) {
  padding: 0 360px;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  @include e(con) {
    display: flex;
  }
  @include e(left-nav) {
    width: 252px;
    box-sizing: border-box;
    padding-left: 20px;
    padding-top: 20px;
    flex-shrink: 0;
  }
  @include e(right-img) {
    flex: 1;
    height: 300px;
  }
  @include e(img) {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  @include e(nav) {
    position: relative;
    margin-top: 28px;
  }
  @include e(nav-list) {
    display: flex;
    padding-right: 100px;
    justify-content: center;
    height: 53px;
    overflow: hidden;
    @include m(more) {
      justify-content: flex-start;
      flex-wrap: wrap;
      height: fit-content;
    }
    @include m(flex-start) {
      justify-content: flex-start;
      flex-wrap: wrap;
    }
  }
  @include e(nav-item) {
    line-height: 19px;
    font-size: $--size-base;
    color: $--color-grey-7;
    cursor: pointer;
    width: 183px;
    display: flex;
    justify-content: center;
    transition: all ease-in-out 0.3s;
    @include m(active) {
      .sky-hc-content-header__nav-item-txt {
        font-weight: bold;
        color: $--color-primary;
        position: relative;
        &::after {
          display: block;
          content: '';
          width: 100%;
          height: 3px;
          background: $--color-primary;
          position: absolute;
          left: 0px;
          bottom: 0px;
        }
      }
    }
  }
  @include e(nav-item-txt) {
    width: fit-content;
    padding: 17px 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;
  }
  @include e(nav-more) {
    display: flex;
    align-items: center;
    position: absolute;
    right: 0px;
    top: 16px;
    cursor: pointer;
  }
  @include e(nav-more-txt) {
    font-size: $--size-base;
    line-height: 19px;
    color: $--color-grey-7;
  }
  @include e(nav-more-icon) {
    font-size: $--font-size-big;
  }
}
</style>
